import { Selfverification } from "../../../components";
import { Container, Wrapper, ContentWrapper, Main } from "./styles";

const SelfVerification = () => {
  return (
    <Main>
      <Container>
        <Wrapper>
          <ContentWrapper>
            <Selfverification />
          </ContentWrapper>
        </Wrapper>
      </Container>
    </Main>
  );
};

export default SelfVerification;
